// src/components/CircularTimer.js
import React from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './CircularTimer.css';
import { usePersistentTimer } from '../hooks/usePersistentTimer';

// --- ICONS ---
const PlayIcon = () => (
  <svg width="40%" height="40%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 5.5V18.5L19 12L5 5.5Z" fill="#000" stroke="#000" strokeWidth="2" strokeLinejoin="round"/>
  </svg>
);

const PauseIcon = () => (
  <svg width="40%" height="40%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 5V19M16 5V19" stroke="#000" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
// ---

const CircularTimer = ({ durationInMinutes, storageKey }) => {
  // --- NEW: Graceful fallback ---
  const validDuration = (durationInMinutes && !isNaN(durationInMinutes)) ? durationInMinutes : 0;
  
  const { displayTime, percentage, isRunning, togglePlayPause } = usePersistentTimer(
    validDuration,
    storageKey
  );

  // If duration was invalid, render a disabled "N/A" timer
  if (validDuration === 0) {
    return (
      <div className="circular-timer-container" style={{ cursor: 'default' }}>
          {/* This inline style is to re-show the text we hide in the CSS file */}
          <style>{`.circular-timer-container .CircularProgressbar-text { display: block !important; }`}</style>
          <CircularProgressbar
            value={0}
            text="N/A"
            styles={buildStyles({
              textColor: '#aaa',
              pathColor: '#d6d6d6',
              trailColor: '#d6d6d6',
              textSize: '28px',
            })}
          />
      </div>
    );
  }

  // This is the normal, functioning timer
  return (
    <div
      className="circular-timer-container"
      onClick={togglePlayPause}
      title={isRunning ? 'Pause' : 'Resume'}
    >
      {/* --- THIS IS THE FIX --- */}
      {/* This forces the text to be visible, overriding any .css file rules */}
      <style>{`.circular-timer-container .timer-text { display: block !important; }`}</style>
      
      <CircularProgressbar
        value={percentage}
        styles={buildStyles({
          textColor: '#000',
          pathColor: '#3e98c7',
          trailColor: '#d6d6d6',
          textSize: '28px', // This is hidden, but hook logic uses it
          pathTransitionDuration: 0.2,
        })}
      />
      <div className="timer-control-overlay">
        {/* Text and icon are layered. CSS handles showing one or the other. */}
        <div className="timer-text">{displayTime}</div>
        <div className="timer-icon">
          {isRunning ? <PauseIcon /> : <PlayIcon />}
        </div>
      </div>
    </div>
  );
};

export default CircularTimer;